import axios from "axios";
import settingStore from "@/stores/setting";
import authStore from "@/stores/auth";

export default () => {
  const serviceUri = settingStore.state.serviceUri;
  const accessToken = authStore.state.accessToken;
  const headers = {};

  if (accessToken) {
    headers.Authorization = 'Bearer ' + accessToken;
  }
  
  return axios.create({
    baseURL: serviceUri,
    headers: headers
  });
};
